module.exports = __webpack_public_path__ + "img/edit-profiel.be828762.svg";